import { Spinner } from 'reactstrap';
import './style.css';

const Button = ({ title, assignClassName, loading, addedStyle, onClick }) => {
  return (
    <button
      type="button" // use "button" unless you explicitly want submit
      className={`${
        assignClassName ? assignClassName : 'btn btn-primary adjust-btn'
      }`}
      style={addedStyle}
      onClick={onClick} // 👈 attach here
    >
      {loading ? <Spinner size="sm" /> : title}
    </button>
  );
};

export default Button;
